import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import { Plus, Search, Settings2 } from "lucide-react";
import { ListLayout } from "@/components/custom/list-layout/list-layout";
import { Loader } from "@/components/custom/loader";
import { ResourceViewSwitcher } from "@/components/custom/resources/resource-view-switcher";

// The shell (header, description, create action, filters) is identical to the
// loaded list so it stays put when data resolves. The body is intentionally
// view-agnostic: the loaded page can be an empty hero, one section, or several
// grouped tables depending on which bindings exist, so a generic loader avoids
// committing to a shape we'd have to shift away from.
export const MCPGatewaysListSkeleton = () => (
  <ListLayout
    actions={
      <Button disabled size="sm">
        <Plus className="mr-2 size-4" />
        Create MCP gateway
      </Button>
    }
    description="Choose which apps your agents can use, all from one place."
    filters={
      <>
        <div className="flex items-center gap-3">
          <div className="relative max-w-md">
            <Search className="absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              className="h-9 w-full pl-9"
              disabled
              placeholder="Search MCP gateways..."
            />
          </div>
          <div className="flex items-center gap-2">
            <Button
              className="h-9 gap-2 px-3"
              disabled
              size="sm"
              variant="outline"
            >
              <Settings2 className="size-4" />
              <span className="hidden sm:inline">Columns</span>
            </Button>
          </div>
        </div>
        <ResourceViewSwitcher />
      </>
    }
    title="MCP gateways"
  >
    <output className="flex min-h-[360px] w-full items-center justify-center rounded-lg border border-border/60 bg-background/35 md:min-h-[430px]">
      <Loader />
      <span className="sr-only">Loading MCP gateways</span>
    </output>
  </ListLayout>
);
